import React, { useState, useEffect } from 'react'
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  message,
  Form,
  Select,
  Tooltip,
  Checkbox,
  Spin,
  Alert
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { InputGroup } from 'reactstrap'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { SUPPLIER } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  isEmailValid
} from '../../../appRedux/actions/GlobalMethods'
// import { REACT_APP_BUS_FIRST_NAME } from '../../../constants/StoreSetting'
import { TableName } from '../../../constants/TableName'
import { env } from '../../../env'

const { REACT_APP_BUS_FIRST_NAME } = env
const { Footer } = Layout
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24
      //offset: 0,
    },
    sm: {
      span: 16
      //offset: 0,
    },
    md: {
      span: 24
      //  offset: 0,
    }
  }
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const Suppliers = ({ match }) => {
  const urlSupplierID = parseInt(match.params.id)
  const history = useHistory()
  const dispatch = useDispatch()
  //if (isNaN(urlSupplierID)) {
  //    history.push("/Dashboard/products/supplier/add");
  //}
  const isAddMode = !urlSupplierID
  let supplierID = isAddMode ? 0 : urlSupplierID
  const methodType = isAddMode ? BEHAVIOUR_TYPE.POST : BEHAVIOUR_TYPE.UPDATE
  const redirectToadd = () => {
    history.push('/Dashboard/products/supplier/add')
  }
  const redirectToListing = () => {
    history.push('/Dashboard/products/supplier')
  }
  const [form] = Form.useForm()
  const onFinishFailed = errorInfo => {
    message.error('Please enter supplier name')
  }
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [supplier, setSupplier] = useState({})
  const [isLoading, SetisLoading] = React.useState({
    isLoading: isAddMode ? false : true
  })
  const [isRegistering, SetisRegistering] = React.useState({
    isRegistering: false
  })
  const [PosameasPy, SetPosameasPy] = React.useState({ PosameasPy: true })
  const [countriesObject, setcountriesObject] = React.useState([
    { id: 1, label: '' }
  ])

  useEffect(() => {
    dispatch(setCommonConfigs(SUPPLIER))
    getCountriesData()
    if (!isAddMode) {
      ds.getSuppliers({ supplierID: urlSupplierID }, BEHAVIOUR_TYPE.GET)
        .then(supplier => {
          if (
            supplier != null &&
            Array.isArray(supplier.data.data) &&
            supplier.data.data.length != 0
          ) {
            let supplierFormData = supplier.data.data

            if (supplier.data.msgCode === 'GENERAL_SUCCESS') {
              // ;
              form.setFieldsValue({
                supplierName: supplierFormData[0].supplierName
              })
              form.setFieldsValue({
                description: supplierFormData[0].supplierDescription
              })
              form.setFieldsValue({
                defaultMarkup:
                  supplierFormData[0].defaultMarkupPercentage.toString()
              })
              form.setFieldsValue({ firstName: supplierFormData[0].firstName })
              form.setFieldsValue({ lastName: supplierFormData[0].lastName })
              form.setFieldsValue({
                companyName: supplierFormData[0].companyName
              })
              form.setFieldsValue({ email: supplierFormData[0].email })
              form.setFieldsValue({ phoneNo: supplierFormData[0].phoneNo })
              form.setFieldsValue({ mobileNo: supplierFormData[0].mobileNo })
              form.setFieldsValue({ website: supplierFormData[0].website })
              form.setFieldsValue({ twitter: supplierFormData[0].twitter })
              form.setFieldsValue({
                Py_street1: supplierFormData[0].physical_Street1
              })
              form.setFieldsValue({
                Py_street2: supplierFormData[0].physical_Street2
              })
              form.setFieldsValue({
                Py_subburb: supplierFormData[0].physical_Suburb
              })
              form.setFieldsValue({
                Py_postcode: supplierFormData[0].physical_PostCode
              })
              form.setFieldsValue({
                Py_state: supplierFormData[0].physical_State
              })
              form.setFieldsValue({
                Py_country: supplierFormData[0].physical_CountryID
              })
              form.setFieldsValue({
                Po_street1: supplierFormData[0].postal_Street1
              })
              form.setFieldsValue({
                Po_street2: supplierFormData[0].postal_Street2
              })
              form.setFieldsValue({
                Po_subburb: supplierFormData[0].postal_Suburb
              })
              form.setFieldsValue({
                Po_postcode: supplierFormData[0].postal_PostCode
              })
              form.setFieldsValue({
                Po_state: supplierFormData[0].postal_State
              })
              form.setFieldsValue({
                Po_country: supplierFormData[0].postal_CountryID
              })
              //form.setFieldsValue({ PosameasPy: supplierFormData[0].isPoSameasPhy });
              form.setFieldsValue({ faxNo: supplierFormData[0].fax })
              SetPosameasPy({ PosameasPy: supplierFormData[0].isPoSameasPhy })
              setSupplier(supplierFormData)
              SetisLoading({ isLoading: false })
            } else if (supplier.data.msgCode === 'GENERAL_ERROR') {
              history.push('/Dashboard/products/supplier')
            }
          } else {
            history.push('/Dashboard/products/supplier')
          }
        })
        .catch(e => {
          notAllowMsgCheck(e)
        })
    }
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  async function getCountriesData () {
    const getcountriesData = ds.getRegistrationData()
    await getcountriesData.then(response => {
      setcountriesObject(response.data.data.countriesOptions)
    })
  }
  async function createUpdateUser (values) {
    SetisRegistering({ isRegistering: true })
    let addUpdateDeleteSupplier = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .addUpdateDeleteSupplier(
        {
          SupplierID: supplierID,
          SupplierName: values.supplierName,
          SupplierDescription: values.description,
          DefaultMarkupPercentage: values.defaultMarkup,
          FirstName: values.firstName,
          LastName: values.lastName,
          CompanyName: values.companyName,
          Email: values.email,
          PhoneNo: values.phoneNo,
          MobileNo: values.mobileNo,
          Website: values.website,
          Twitter: values.twitter,
          Fax: values.faxNo,
          Physical_Street1: values.Py_street1,
          Physical_Street2: values.Py_street2,
          Physical_Suburb: values.Py_subburb,
          Physical_PostCode: values.Py_postcode,
          Physical_State: values.Py_state,
          Physical_CountryID: values.Py_country,
          Postal_Street1: values.Po_street1,
          Postal_Street2: values.Po_street2,
          Postal_Suburb: values.Po_subburb,
          Postal_PostCode: values.Po_postcode,
          Postal_State: values.Po_state,
          Postal_CountryID: values.Po_country,
          IsRemove: false,
          IsPoSameasPhy: PosameasPy.PosameasPy ? true : false
        },
        methodType
      )
      .then(response => (addUpdateDeleteSupplier.data = response.data))
      .catch(e => {
        notAllowMsgCheck(e)
      })

    if (addUpdateDeleteSupplier.data.msgCode == 'GENERAL_SUCCESS') {
      message.success(
        addUpdateDeleteSupplier.data.msgDescription + ' Product Supplier'
      )
    }

    if (addUpdateDeleteSupplier.data.msgCode == 'GENERAL_SUCCESS') {
      message.success(
        addUpdateDeleteSupplier.data.msgDescription + ' Product Supplier'
      )

      setTimeout(() => {
        history.push('/Dashboard/products/Supplier')
      }, 1000)
      SetisRegistering({ isRegistering: false })
    }

    if (addUpdateDeleteSupplier.data.msgCode == 'GENERAL_ERROR') {
      message.error(addUpdateDeleteSupplier.data.msgDescription)
      history.push('/Dashboard/products/Supplier')
    }
  }

  const onFinish = async values => {
    createUpdateUser(values)
  }

  function onChangePosameasPy (e) {
    // console.log(`checked = ${e.target.checked}`)
    SetPosameasPy({ PosameasPy: e.target.checked ? true : false })
  }
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.Suppliers,
      SearchValue: value,
      ID: `${supplierID}&&_bd98-6131-47dd-8ac8-4bd1856d2a60`
    }
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback('This Supplier name exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }
  return (
    <div className='Content-wrapper AddSupplier-pg'>
      {isLoading.isLoading ? (
        <Skeleton count={12} height={30} />
      ) : (
        <>
          <Spin tip='Loading...' spinning={isRegistering.isRegistering}>
            

          <div className="back-arrow-h1">
        <h1 className="d-flex align-items-center">
                  
                    <ArrowLeftOutlined
                      className='dk-vertical-align'
                      onClick={redirectToListing}
                    />
                    <span className="mx-2">
                    {' '}
                    {isAddMode ? (
                      <IntlMessages id='products.suppliers.addsupplier' />
                    ) : (
                      'Edit Supplier -- ' + form.getFieldValue('supplierName')
                    )}
                    </span>
                  </h1>
                </div>
             

                <Row className="ant-row dk-row-bg-color m-0 Sec-heading-bg">
                <Col lg={12} md={12} sm={12} xs={24}>
                <p className="title vd-hero-intro custom-font-color-black m-0">
                    {isAddMode ? (
                      <IntlMessages id='products.suppliers.add.createnewsupplier' />
                    ) : (
                      "Edit supplier's details."
                    )}
                  </p>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                <div className="pg-header-btn">
                    <Button
                      className='dk-btn-cancel dk-wd-auto'
                      type='primary'
                      onClick={redirectToListing}
                      size='large'
                    >
                      <IntlMessages id='products.suppliers.cancel' />
                    </Button>
                    <Button
                      className='dk-btn-add dk-wd-auto'
                      disabled={isRegistering.isRegistering}
                      form='SupplierForm'
                      htmlType='submit'
                      type='primary'
                      size='large'
                    >
                      {isAddMode ? (
                        <IntlMessages id='products.suppliers.addsupplier' />
                      ) : (
                        'Edit Supplier'
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>


              <div className='custom-mg-top-25'>

                <Row className='Details-1'>

                  <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                      <IntlMessages id='products.suppliers.details' />
                    </h2>
                    <p className='dk-font-size-15'>
                      <IntlMessages
                        id='products.suppliers.detailsdescription'
                        values={{
                          strong: chunks => <strong>{chunks}</strong>,
                          bus_name_first: REACT_APP_BUS_FIRST_NAME
                        }}
                      />
                    </p>
                  </Col>

                  <Col lg={18} md={24} sm={24} xs={24}>
                    <Form
                      {...formItemLayout}
                      form={form}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      initialValues={{
                        prefix: '86'
                      }}
                      scrollToFirstError
                      id='SupplierForm'
                    >
                      <InputGroup size='large' className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                          name='supplierName'
                          label={
                            <IntlMessages id='products.suppliers.suppliername' />
                          }
                          rules={[
                            {
                              required: true,
                              message: 'Please enter your supplier name.'
                            },
                            {
                              validator: valideDuplicateName
                            }
                          ]}
                        >
                          <Input maxLength={35} /*placeholder={<IntlMessages id="products.suppliers.suppliername" />*/
                          />
                        </Form.Item>

                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='defaultMarkup'
                          label={
                            <IntlMessages id='products.suppliers.defaultmarkup' />
                          }
                        >
                          <Input placeholder='0' defaultValue={0} />
                        </Form.Item>
                      </InputGroup>

                      <Form.Item
                        className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment md-inner-pad-0'
                        name='description'
                        label={
                          <IntlMessages id='products.suppliers.description' />
                        }
                      >
                        <Input.TextArea  maxLength={350}
                          /*placeholder={<IntlMessages id="products.suppliers.description" />}*/ style={{
                            height: '100px'
                          }}
                        />
                      </Form.Item>
                    </Form>
                  </Col>
                </Row>


                <Divider className='mt-3 mb-4' />

                <Row className='Contact-Info'>

                  <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                      <IntlMessages id='products.suppliers.contactinfo' />
                    </h2>
                    <p className='dk-font-size-15'>
                      <IntlMessages id='products.suppliers.contactinfodescription' />
                    </p>
                  </Col>

                  <Col lg={18} md={24} sm={24} xs={24}>
                    <Form
                      {...formItemLayout}
                      form={form}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      initialValues={{
                        prefix: '86'
                      }}
                      scrollToFirstError
                      id='SupplierForm'
                    >
                      <InputGroup size='large' className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='firstName'
                          label={
                            <IntlMessages id='products.suppliers.firstname' />
                          }
                        >
                          <Input  maxLength={30} /*placeholder={<IntlMessages id="products.suppliers.firstname" />}*/
                          />
                        </Form.Item>

                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='lastName'
                          label={
                            <IntlMessages id='products.suppliers.lastname' />
                          }
                        >
                          <Input  maxLength={30}  /*placeholder={<IntlMessages id="products.suppliers.lastname" />}*/
                          />
                        </Form.Item>
                      </InputGroup>

                      <InputGroup size='large' className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='companyName'
                          label={
                            <IntlMessages id='products.suppliers.companyname' />
                          }
                        >
                          <Input  maxLength={30}  /*placeholder={<IntlMessages id="products.suppliers.companyname" />}*/
                          />
                        </Form.Item>

                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='email'
                          label={<IntlMessages id='products.suppliers.email' />}
                          rules={[
                            // {
                            //   type: "email",
                            //   message: "Please enter a valid email address.",
                            // },
                            {
                              validator: isEmailValid
                            }
                          ]}
                        >
                          <Input /*placeholder={<IntlMessages id="products.suppliers.demoemail" />}*/
                          />
                        </Form.Item>
                      </InputGroup>

                      <InputGroup size='large' className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='phoneNo'
                          label={
                            <IntlMessages id='products.suppliers.phoneno' />
                          }
                          rules={[
                            {
                              pattern: /^[0-9+\-() ]*$/,
                              message: 'Please enter a valid phone number.',
                            },
                          ]}
                        >
                          <Input  maxLength={30}  className='w-100'/>
                        </Form.Item>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='mobileNo'
                          label={
                            <IntlMessages id='products.suppliers.mobileno' />
                          }
                          rules={[
                            {
                              pattern: /^[0-9+\-() ]*$/,
                              message: 'Please enter a mobile number.',
                            },
                          ]}
                        >
                          <Input  maxLength={30}  /*placeholder={<IntlMessages id="products.suppliers.mobileno" />}*/
                          />
                        </Form.Item>
                      </InputGroup>

                      <InputGroup size='large' className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='faxNo'
                          label={<IntlMessages id='products.suppliers.fax' />}
                        >
                          <Input   maxLength={50}  className='w-100'/>
                        </Form.Item>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='website'
                          label={
                            <IntlMessages id='products.suppliers.website' />
                          }
                        >
                          <Input  /*placeholder={<IntlMessages id="products.suppliers.website" />}*/
                          />
                        </Form.Item>
                      </InputGroup>

                      <InputGroup size='large' className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='twitter'
                          label={
                            <IntlMessages id='products.suppliers.twitter' />
                          }
                        >
                          <Input className='w-100'/>
                        </Form.Item>
                      </InputGroup>
                    </Form>
                  </Col>
                </Row>

                <Divider className='mt-3 mb-4' />

                <Row className='Addresses'>

                  <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                      <IntlMessages id='products.suppliers.addresses' />
                    </h2>
                  </Col>

                  <Col lg={18} md={24} sm={24} xs={24}>
                    <Form
                      {...formItemLayout}
                      form={form}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      initialValues={{
                        prefix: '86'
                      }}
                      scrollToFirstError
                      id='SupplierForm'
                    >
                      <h2 className="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                        <IntlMessages id="products.suppliers.physicaladdress" />
                      </h2>
                      <InputGroup size="large" className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='Py_street1'
                          label={
                            <IntlMessages id='products.suppliers.street' />
                          }
                        >
                          <Input  maxLength={300}  className='w-100'/>
                        </Form.Item>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-custom-alignment'
                          name='Py_street2'
                          label={
                            <IntlMessages id='products.suppliers.street' />
                          }
                        >
                          <Input   maxLength={300} /*placeholder={<IntlMessages id="products.suppliers.street" />}*/
                          />
                        </Form.Item>
                      </InputGroup>
                      <InputGroup size="large" className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='Py_subburb'
                          label={
                            <IntlMessages id='products.suppliers.suburb' />
                          }
                        >
                          <Input  maxLength={300}  className='w-100'/>
                        </Form.Item>
                        <Form.Item
                          className='ant-form-item-label-custom  ant-form-custom-alignment'
                          name='Py_postcode'
                          label={
                            <IntlMessages id='products.suppliers.postcode' />
                          }
                        >
                          <Input  maxLength={30}  /*placeholder={<IntlMessages id="products.suppliers.postcode" />}*/
                          />
                        </Form.Item>
                      </InputGroup>
                      <InputGroup size="large" className='md-col-100'>
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment'
                          name='Py_state'
                          label={<IntlMessages id='products.suppliers.state' />}
                        >
                          <Input  maxLength={50}  className='w-100'/>
                        </Form.Item>

                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                          name='Py_country'
                          label={
                            <IntlMessages id='products.suppliers.country' />
                          }
                        >
                          <Select
                            placeholder={
                              <IntlMessages id='products.suppliers.selectcountry' />
                            }
                            showSearch
                            optionFilterProp='children'
                          >
                            {countriesObject &&
                              countriesObject.map((e, key) => {
                                return (
                                  <option key={key} value={e.id}>
                                    {e.label}
                                  </option>
                                )
                              })}
                          </Select>
                        </Form.Item>
                      </InputGroup>

                      <Form.Item
                        className='ant-form-item-label-custom ant-form-custom-alignment md-inner-pad-0'
                        name='PosameasPy'
                        valuePropName={PosameasPy.PosameasPy ? true : false}
                      >
                        <Checkbox
                          onChange={onChangePosameasPy}
                          checked={PosameasPy.PosameasPy ? true : false}
                        >
                          <IntlMessages id='products.suppliers.posameaspy' />
                        </Checkbox>
                      </Form.Item>
                      {!PosameasPy.PosameasPy ? (
                        <>
                          <h2 class="custom-font-weight-500 custom-font-color-black mt-3">
                            <IntlMessages id='products.suppliers.postaladdress' />
                          </h2>
                          <InputGroup size='large' className='md-col-100'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='Po_street1'
                              label={
                                <IntlMessages id='products.suppliers.street' />
                              }
                            >
                              <Input   maxLength={300}  className='w-100' />
                            </Form.Item>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-custom-alignment'
                              name='Po_street2'
                              label={
                                <IntlMessages id='products.suppliers.street' />
                              }
                            >
                              <Input /*placeholder={<IntlMessages id="products.suppliers.street" />}*/
                              />
                            </Form.Item>
                          </InputGroup>
                          <InputGroup size='large' className='md-col-100'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='Po_subburb'
                              label={
                                <IntlMessages id='products.suppliers.suburb' />
                              }
                            >
                              <Input className='w-100'/>
                            </Form.Item>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-custom-alignment'
                              name='Po_postcode'
                              label={
                                <IntlMessages id='products.suppliers.postcode' />
                              }
                            >
                              <Input /*placeholder={<IntlMessages id="products.suppliers.postcode" />}*/
                              />
                            </Form.Item>
                          </InputGroup>
                          <InputGroup
                            size='large'
                            className='md-col-100'
                          ></InputGroup>
                          <Form.Item
                            className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment md-inner-pad-0'
                            name='Po_country'
                            label={
                              <IntlMessages id='products.suppliers.country' />
                            }
                          >
                            <Select
                              showSearch
                              optionFilterProp='children'
                              placeholder={
                                <IntlMessages id='products.suppliers.selectcountry' />
                              }
                            >
                              {countriesObject &&
                                countriesObject.map((e, key) => {
                                  return (
                                    <option key={key} value={e.id}>
                                      {e.label}
                                    </option>
                                  )
                                })}
                            </Select>
                          </Form.Item>{' '}
                        </>
                      ) : (
                        ''
                      )}
                    </Form>
                  </Col>
                </Row>

              </div>
          
          </Spin>
        </>
      )}
    </div>
  )
}
export default Suppliers
